<template>

	<div class="page">
		<div class="main">
			<div class="main_tabs">
				<div :class="productType == '' ? 'tabs_item' : 'tabs_item2'" @click="changeType('')">
					全部
				</div>
				
				<div :class="productType == 3 ? 'tabs_item' : 'tabs_item2'" style="margin-left: 10px;" @click="changeType('3')">
					出境险
				</div>
				
				<div :class="productType == 4 ? 'tabs_item' : 'tabs_item2'" style="margin-left: 10px;" @click="changeType('4')">
					国内险
				</div>
				<div class="border">

				</div>
			</div>
			

			<div class="main_item" v-if="list.length > 0">
				<div class="item" v-for="(item,index) in list" :key="index">
					<div class="item_img">
						<el-image :src="item.ImagePcUrl" fit="fill"></el-image>
						<el-image v-if="index == 0" style="width: 4.0625rem;height:4.0625rem;position: absolute;top: 0;left: 1.25rem;" src="https://file.aavisa.com/browser-upload-file/133e4157-dba0-4b70-988b-03a73f6da4e6.jpg" fit="fill"></el-image>
					</div>

					<div class="item_info">
						<div class="info_title">
							{{item.ProductName}}
						</div>
						<div class="info_tips" v-for="(items,indexs) in item.NewProductTitle" :key="indexs">
							<div class=""></div>
							{{items}}
						</div>
					</div>

					<div class="item_handle">
						<el-image :src="item.CompanyLogo" fit="fill" style="width: 7.5rem;"></el-image>

						<el-button type="primary" round @click="goLink(item.Id)">立即办理</el-button>
					</div>
				</div>
			</div>


			<el-empty v-else description="暂无数据" :image-size="300"></el-empty>
		</div>
		<login ref="login"></login>
	</div>
</template>

<script>
	import login from '../../components/login/login.vue'
	export default {
		components: {
			login
		},
		data() {
			return {
				pageIndex: 1,
				pageSize: 5,
				productType: '',
				list: []
			}
		},
		created() {
			this.ProductList()
		},

		methods: {
			ProductList() {
				let {
					pageIndex,
					pageSize,
					productType
				} = this
				this.$api.ProductList({
					pageIndex,
					pageSize,
					productType,
					productName: '',
					isLevel: '',
					companyId: ''
				}).then(res => {
					let {
						data,
						status
					} = res.data
					if (status == 200) {
						for (let i = 0; i < data.length; i++) {
							data[i].NewProductTitle = data[i].NewProductTitle.split(",")
						}
						this.list = data
					} else {
						this.list = []
					}
				})
			},

			changeType(type) {
				this.productType = type
				this.ProductList()
			},

			goLink(id) {
				if (!this.$refs.login.checkLogin()) return false;
				this.$router.push('/productDetile?id=' + id)
			},
		}
	}
</script>

<style lang='less' scoped>
	.page {

		.main {
			width: 75rem;
			height: auto;
			margin: 1.5rem auto;
		}

		.main_tabs {
			width: 100%;
			padding: 1rem 1.25rem;
			background-color: #fff;
			text-align: left;
			border-bottom: 0.125rem solid #eeeeee;

			&>.tabs_item {
				display: inline-block;
				position: relative;
				padding-bottom: 1.125rem;
				color: #599fff;
			}

			&>.tabs_item:before {
				content: "";
				display: block;
				width: 100%;
				height: 0.1875rem;
				background-color: #599fff;
				position: absolute;
				bottom: 0;
			}
			
			.tabs_item2{
				display: inline-block;
				position: relative;
				padding-bottom: 1.125rem;
				color: #999999;
			}

			&>.border {
				width: 100%;
				height: 100%;
				border-bottom: 0.125rem solid #eeeeee;
				box-sizing: border-box;
			}
		}

		.main_item {
			width: 100%;
			height: auto;
			margin-top: 1.25rem;

			.item {
				width: 100%;
				height: 14.875rem;
				padding: 1.25rem;
				background-color: #ffffff;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 1.25rem;

				.item_img {
					width: 21.875rem;
					height: 100%;
					position: relative;
					.el-image {
						height: 100%;
					}

					.el-image__inner {
						height: 100%;
					}
				}

				.item_info {
					width: 38.05rem;
					height: 100%;

					.info_title {
						font-size: 1.5rem;
						font-weight: 600;
						text-align: left;
					}

					.info_tips {
						text-align: left;
						display: flex;
						align-items: center;
						margin-top: 1.25rem;
						margin-bottom: 1.25rem;
						color: #666666;

						&>div {
							width: 0.625rem;
							height: 0.625rem;
							background-color: #ff8033;
							border-radius: 50%;
							margin-right: 0.4375rem;
						}
					}
				}

				.item_handle {
					width: 12.875rem;
					height: 100%;
					position: relative;

					.el-image {
						position: absolute;
						top: 0;
						right: 0;
					}

					.el-button {
						background-color: #599fff !important;
						border-color: #599fff !important;
						margin: 0.25rem;
						font-size: 1rem;
						position: absolute;
						top: 7.625rem;
						right: 0;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/Insurance/index.vue